var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 21023"
  }, /*#__PURE__*/React.createElement("path", {
    id: "U",
    d: "M8.63281 0.695312V0.40625H12.3828V0.695312H11.9844C11.5677 0.695312 11.2474 0.869792 11.0234 1.21875C10.9141 1.38021 10.8594 1.75521 10.8594 2.34375V6.64062C10.8594 7.70312 10.7526 8.52865 10.5391 9.11719C10.3307 9.70052 9.91667 10.2031 9.29688 10.625C8.68229 11.0417 7.84375 11.25 6.78125 11.25C5.625 11.25 4.7474 11.0495 4.14844 10.6484C3.54948 10.2474 3.125 9.70833 2.875 9.03125C2.70833 8.56771 2.625 7.69792 2.625 6.42188V2.28125C2.625 1.63021 2.53385 1.20312 2.35156 1C2.17448 0.796875 1.88542 0.695312 1.48438 0.695312H1.08594V0.40625H5.66406V0.695312H5.25781C4.82031 0.695312 4.50781 0.833333 4.32031 1.10938C4.1901 1.29688 4.125 1.6875 4.125 2.28125V6.89844C4.125 7.3099 4.16146 7.78125 4.23438 8.3125C4.3125 8.84375 4.45052 9.25781 4.64844 9.55469C4.84635 9.85156 5.13021 10.0964 5.5 10.2891C5.875 10.4818 6.33333 10.5781 6.875 10.5781C7.56771 10.5781 8.1875 10.4271 8.73438 10.125C9.28125 9.82292 9.65365 9.4375 9.85156 8.96875C10.0547 8.49479 10.1562 7.69531 10.1562 6.57031V2.28125C10.1562 1.61979 10.0833 1.20573 9.9375 1.03906C9.73438 0.809896 9.43229 0.695312 9.03125 0.695312H8.63281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 78",
    d: "M0 5H13V6H0V5Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStroke);
export default __webpack_public_path__ + "static/media/stroke.63f484a12038dbd9451323241bd380ec.svg";
export { ForwardRef as ReactComponent };